// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"967ed910","661":"dc4803fd","787":"cda612ba"}[chunkId] + ".chunk.js";
};